function initLanguagePopup() {
  const popup = document.getElementById('LanguagePopup');
  if (!popup) return;
  if (popup.dataset.languagePopupInitialized === 'true') return;
  popup.dataset.languagePopupInitialized = 'true';

  const TRANSITION_MS = 250;
  const openButtons = document.querySelectorAll('[data-open-language]');
  const closeButtons = popup.querySelectorAll('[data-close-language]');
  const popupModal = popup.querySelector('.language-popup-modal');
  const options = popup.querySelectorAll('[data-language-value]');
  const localeInput = popup.querySelector('[data-language-input]');
  const form = popup.querySelector('#LanguagePopupForm');
  const activeLocale = (localeInput?.value || '').toLowerCase();

  popup.classList.remove('is-open');
  popup.setAttribute('aria-hidden', 'true');
  popup.setAttribute('hidden', '');

  if (options.length) {
    options.forEach((option) => {
      const isActive = (option.dataset.languageValue || '').toLowerCase() === activeLocale;
      option.classList.toggle('is-active', isActive);
      if (isActive) {
        option.setAttribute('aria-current', 'true');
      } else {
        option.removeAttribute('aria-current');
      }
    });
  }

  const openPopup = () => {
    const menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer && menuDrawer.classList.contains('menu-opening')) {
      menuDrawer.close();
    }

    popup.removeAttribute('hidden');
    requestAnimationFrame(() => {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    window.setTimeout(() => {
      popup.setAttribute('hidden', '');
    }, TRANSITION_MS);
  };

  const togglePopup = () => {
    if (popup.classList.contains('is-open')) {
      closePopup();
    } else {
      openPopup();
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      togglePopup();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
    });
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup || event.target.classList.contains('language-popup-overlay')) {
      closePopup();
    }
  });

  popupModal?.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  options.forEach((option) => {
    option.addEventListener('click', (event) => {
      event.preventDefault();
      const selectedLocale = option.dataset.languageValue;
      if (!selectedLocale || !localeInput || !form) return;
      localeInput.value = selectedLocale;
      form.submit();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  document.addEventListener('menu-drawer:open', () => {
    if (popup.classList.contains('is-open')) closePopup();
  });
}

document.addEventListener('DOMContentLoaded', initLanguagePopup);
document.addEventListener('shopify:section:load', initLanguagePopup);
